<template>
  <section class="">
    <div class="shadow p-3 rounded-lg bg-white">
      <h3 class="mb-2 font-semibold md:text-2xl text-lg">Posts</h3>
      <div class="overflow-auto">
        <section v-if="!isAdminView" class="ring-1 ring-gray-200 px-4 py-3 pb-8 mt-4 rounded">
          <div class="flex items-center">
            <Avatar :classStr="'h-8 w-8 mr-2'" :src="profileAvatar" />
            <p class="capitalize text-xl text-gray-dark">
              {{ profile && profile.f_name }}
              {{ profile && profile.l_name }}
            </p>
          </div>
          <div class="mt-4">
            <label class="block">
              <textarea
                class="w-full h-24 px-3 py-2 text-base text-gray-700 placeholder-gray-600 border rounded-lg focus:outline-none border-1 border-borderColor"
                :class="{ 'ring-red-700': $v.body.$error }"
                placeholder="Share your updates with your followers."
                v-model="$v.body.$model"
              ></textarea>
            </label>
            <div v-if="$v.body.$error">
              <small class="text-red-500" v-if="!$v.body.required">
                Description field is required.
              </small>
              <small class="text-red-500" v-if="!$v.body.minLength">
                Description must have at least 25 letters.
              </small>
              <small class="text-red-500" v-if="!$v.body.maxLength">
                Description must have at most 500 letters.
              </small>
            </div>
          </div>
          <div class="py-4">
            <div class="float-right">
              <button
                type="button"
                class="text-green-light px-4 py-1 text-sm"
                @click="postResetHandler"
              >
                Cancel
              </button>
              <button
                class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-dark"
                @click.prevent="postSubmissionHandler"
              >
                Post
              </button>
            </div>
          </div>
        </section>
        <TrainerPostList
          v-if="trainerPostList && trainerPostList.data && trainerPostList.data.length"
          :data="trainerPostList"
          :handlePostLike="handlePostLike"
          :getTrainerPostListHandler="getTrainerPostListHandler"
          :caliberatepagination="caliberatepagination"
          :isAdminView="isAdminView"
        />
        <div v-else-if="noPostsFound">
          <div
            class="flex flex-col justify-center items-center text-xl text-gray-700 mt-8 space-y-8"
          >
            <img
              :src="require(`@/assets/img/my_sessions_no_data.svg`)"
              alt="..."
              class="w-72"
            />
            <div
              class="flex flex-col text-lg justify-center items-center text-center"
            >
              <span> Looks like there is nothing here yet.</span>
              <span>Start sharing posts with your followers above.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import TrainerPostList from "@/components/TrainerPostList";
import { mapActions, mapGetters } from "vuex";
import { Avatar } from "@/components/t-components";

export default {
  components: {
    TrainerPostList,
    Avatar,
  },
  props: {
    profile: {
      type: Object,
    },
    callerComp: {
      type: String
    }
  },
  data() {
    return {
      body: null,
      trainerPosts: [],
      profileAvatar: "",
      noPostsFound: false
    };
  },
  validations: {
    body: {
      required,
      minLength: minLength(25),
      maxLength: maxLength(500),
    },
  },
  computed: {
    ...mapGetters(["trainerPostList", "trainerProfile"]),
    isAdminView () {
      return this.callerComp && this.callerComp.length && this.callerComp === 'adminProfileViewer'
    }
  },
  watch: {
    'trainerPostList': {
      handler (data) {
        data && data.data && data.data.length ? '' : this.noPostsFound = true
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      "trainerPostCreate",
      "getTrainerPostList",
      "postCommentLike",
      "getTrainerProfile",
    ]),

    async postSubmissionHandler() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // console.log("invalid");
      } else {
        const data = {
          body: this.body,
        };
        await this.trainerPostCreate(data).then(() => {
          this.postResetHandler();
          this.caliberatepagination(this.trainerPostList && this.trainerPostList.per_page)
          // this.getTrainerPostList();
        })
        // this.$router.push({
        //   name: "TrainerProfilePostView",
        //   params: { id: this.trainerPosts[0].id },
        // });
        
      }
    },
    postResetHandler () {
      this.body = null
      this.$v.$reset()
    },
    getTrainerPostListHandler (queryPayload) {
      const roleId = this.$route.params.id
      this.isAdminView ? this.$store.dispatch('getAdminTrainerPostList', {query: queryPayload, roleId: roleId}) : this.getTrainerPostList(queryPayload);
    },
    caliberatepagination (perPage) {
      const totalRecords = this.trainerPostList && this.trainerPostList.data && this.trainerPostList.data.length
      const lastPage = Math.ceil(totalRecords / perPage)
      this.trainerPostList.last_page = lastPage
      this.trainerPostList.current_page !== 1 ? this.getTrainerPostListHandler({page: 1}) : ''
    },
    async handlePostLike(postObj, likeFlag) {
      const data = {
        is_liked: 1,
        post_id: postObj.id,
      };
      await this.postCommentLike(data).then(() =>{
        postObj.is_liked ? postObj.like_counter -= 1 : postObj.like_counter += 1
        postObj.is_liked = !postObj.is_liked
      })
    },
  },
  async created() {
    this.trainerProfile && Object.keys(this.trainerProfile).length ? '' : await this.getTrainerProfile();
    await this.getTrainerPostListHandler({page: 1});
    if (this.trainerProfile.profile.thumbnail_url) {
      this.profileAvatar = this.trainerProfile.profile.thumbnail_url;
    }
  },
};
</script>